import { useId } from 'react';
import classNames from 'classnames';
import { Transition } from '@headlessui/react';

import TickIcon from '@crazyegginc/hatch/dist/images/icon-tick-basic.svg?react';

export function Checkbox({
  checked = false,
  disabled = false,
  onChange,
  id,
  label = '',
  error = '',
  checkBoxClass,
  iconCheckBoxClass,
  labelClass,
  ...props
}) {
  const errorId = `checkbox-error-${useId()}`;
  const id2 = useId();
  id = id || id2;

  return (
    <div className="w-full">
      <div className="flex h-6 items-center">
        <div className={classNames('group flex h-6 w-6 items-center rounded-full', 'focus-within:bg-blue-300/30')}>
          <div className={classNames('relative mx-1.25 h-3.5 w-3.5')}>
            <input
              type="checkbox"
              id={id ?? null}
              onChange={onChange}
              checked={checked}
              disabled={disabled}
              aria-invalid={!!error}
              aria-describedby={error ? errorId : null}
              {...props}
              className={classNames('absolute left-0 top-0 opacity-0 h-3.5 w-3.5', {
                'cursor-pointer': !disabled,
                'cursor-not-allowed': disabled,
              })}
            />
            <div
              className={classNames(
                'pointer-events-none absolute left-0 top-0 flex items-center justify-center',
                'rounded-sm border h-3.5 w-3.5',
                {
                  'bg-blue-500': checked && !disabled,
                  'border-blue-500': checked && !error && !disabled,
                  'bg-gray-500': !checked || disabled,
                  'border-gray-300 group-focus-within:border-blue-500': (!checked || disabled) && !error,
                  'border-red-500': !!error,
                  [checkBoxClass]: !!checkBoxClass,
                },
              )}
            >
              <Transition
                show={checked}
                enter="transition ease-in duration-150"
                enterFrom="opacity-0"
                enterTo="opacity-100"
              >
                <TickIcon
                  className={classNames('fill-current h-2 w-2', {
                    'text-white': !disabled,
                    'text-gray-300': disabled,
                    [iconCheckBoxClass]: !!iconCheckBoxClass,
                  })}
                />
              </Transition>
            </div>
          </div>
        </div>
        {!!label && (
          <label
            htmlFor={id}
            className={classNames('text-body-2 ml-1.5 block', {
              'cursor-pointer text-gray-200': !disabled,
              'cursor-not-allowed text-gray-400': disabled,
              [labelClass]: !!labelClass,
            })}
          >
            {label}
          </label>
        )}
      </div>
      {!!error && typeof error === 'string' && (
        <div className="relative h-5" id={errorId}>
          <div className="text-red-500 text-xs absolute -translate-y-1 whitespace-nowrap">{error}</div>
        </div>
      )}
    </div>
  );
}
